import { Component, type ReactNode } from "react";

type Props = { children: ReactNode; resetKey?: string };
type State = { error: Error | null; componentStack: string };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, componentStack: "" };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error("Erro na renderização:", error, info.componentStack);
    this.setState({ componentStack: info.componentStack });

  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null, componentStack: "" });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="loading-page">
          <p>Ops, algo deu errado ao carregar esta página.</p>
          <button className="button button-gold" onClick={() => { this.setState({ error: null }); window.location.href = "/"; }}>
            Voltar ao início
          </button>
          <pre style={{ whiteSpace: "pre-wrap", maxWidth: 640, fontSize: 12, opacity: 0.7, marginTop: 24, textAlign: "left" }}>
            {this.state.error.message}
            {"\n"}
            {this.state.error.stack}
            {this.state.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
